import { useEffect, useState } from 'react'
import styled from 'styled-components'
import colors from '../utils/style/colors'

// 🔐 Ton mot de passe (modifie ici si tu veux)
const ADMIN_PASSWORD = 'jonioppowa52'

const DevisGenerator = () => {
  const [form, setForm] = useState({
    nom: '',
    email: '',
    produit: '',
    quantite: '',
    prix: '',
  })

  const [copied, setCopied] = useState(false)
  const [taxe, setTaxe] = useState(0)

  // 🔐 Protection par mot de passe
  const [authorized, setAuthorized] = useState(false)
  const [inputPassword, setInputPassword] = useState('')

  const handlePasswordSubmit = (e) => {
    e.preventDefault()
    if (inputPassword === ADMIN_PASSWORD) {
      setAuthorized(true)
    } else {
      alert('Mot de passe incorrect.')
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setForm((prev) => ({
      ...prev,
      nom: params.get('nom') || '',
      email: params.get('email') || '',
      produit: params.get('produit') || '',
      quantite: params.get('quantite') || '',
    }))
  }, [])

  const totalHT = (Number(form.prix) || 0) * (Number(form.quantite) * 10 || 0)
  const totalTaxe = (Number(taxe) || 0) * (Number(form.quantite) * 10 || 0)
  const totalTTC = (Number(totalHT) || 0) + (Number(totalTaxe) || 0)

  const mailText = `Bonjour ${form.nom},

Vous nous avez sollicité pour une demande de devis de ${form.produit} et nous vous en remercions.

Voici notre offre indicative valable sous quinzaine avant validation :


Détails pour 1 camion remorque (à multiplier selon votre besoin) :

- Produit : ${form.produit}
- Quantité : ${form.quantite} T (Poids approximatif - 46 bottes / camion remorque, ticket de pesée lors de la livraison)
- Prix unitaire : ${Number(form.prix).toFixed(2)} CHF/100kg
- Taxe Fourrage(Foin, fourrage uniquement) : ${Number(taxe).toFixed(2)} CHF/100kg*

Total HT : ${totalHT.toFixed(2)} CHF + ${totalTaxe.toFixed(2)} CHF (Taxe Fourrage) soit un total de ${totalTTC.toFixed(2)} CHF 
(TVA non applicable - export Suisse)

* Taxe Fourrage : Taxe douanière Suisse sur les produits de Foin et Fourrage, avec possibilité de réajustement chaque mois, s'il devait y avoir changement le jour de la livraison vous en seriez
informé et les modifications serait effectué à la facturation, pour vérifier le montant imposé en douane le jour même nous pouvons vous communiquer les informations sur le site officiel des douanes Suisse.(xtares.admin.ch)


Délai de livraison estimé : 3 à 7 jours minimum après validation, date de livraison fixé ensemble.
Nous prenons en charge les formalités douanières.

N’hésitez pas à revenir vers moi pour confirmer ou ajuster.

Bien cordialement,  
Francky – achatpaille.com`

  const handleCopy = () => {
    navigator.clipboard.writeText(mailText).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  // 🔐 Bloc de protection
  if (!authorized) {
    return (
      <Wrapper>
        <PasswordBox onSubmit={handlePasswordSubmit}>
          <label>Mot de passe requis</label>
          <input
            type="password"
            value={inputPassword}
            onChange={(e) => setInputPassword(e.target.value)}
            placeholder="Mot de passe"
          />
          <button type="submit">Accéder</button>
        </PasswordBox>
      </Wrapper>
    )
  }

  // 🔓 Si autorisé, afficher le générateur
  return (
    <Wrapper>
      <Container>
        <h2>🧾 Générateur de devis</h2>

        <FormSection>
          <Input
            placeholder="Nom client"
            value={form.nom}
            onChange={(e) => setForm({ ...form, nom: e.target.value })}
          />
          <Input
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <Input
            placeholder="Produit (ex: foin de prairie)"
            value={form.produit}
            onChange={(e) => setForm({ ...form, produit: e.target.value })}
          />
          <Input
            type="number"
            placeholder="Quantité"
            value={form.quantite}
            onChange={(e) => setForm({ ...form, quantite: e.target.value })}
          />
          <Input
            type="number"
            step="1"
            placeholder="Prix unitaire (CHF/100kg)"
            value={form.prix}
            onChange={(e) => setForm({ ...form, prix: e.target.value })}
          />
          <Input
            type="number"
            step="1"
            placeholder="Taxe (CHF/100kg)"
            value={taxe}
            onChange={(e) => setTaxe(Number(e.target.value))}
          />
        </FormSection>

        <Recap>
          <p>
            <strong>Total HT :</strong> {totalHT.toFixed(2)} CHF +{' '}
            {totalTaxe.toFixed(2)} CHF (Taxe)
          </p>
        </Recap>

        <Button onClick={handleCopy}>📋 Copier la réponse client</Button>

        {copied && (
          <SuccessText>✅ Texte copié dans le presse-papiers !</SuccessText>
        )}

        <EmailLink
          href={`mailto:${form.email}?subject=Votre devis pour ${encodeURIComponent(
            form.produit,
          )}&body=${encodeURIComponent(mailText)}`}
        >
          ✉️ Envoyer directement par mail
        </EmailLink>
      </Container>
    </Wrapper>
  )
}

export default DevisGenerator

// 🔧 STYLES

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
  margin-bottom: 40px;
`

const Container = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 20px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  font-family: sans-serif;

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    color: ${colors.greenbutton};
  }
`

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 25px;
`

const Input = styled.input`
  padding: 12px 15px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #f9f9f9;
`

const Recap = styled.div`
  background-color: #f2f2f2;
  padding: 15px;
  border-radius: 12px;
  margin-bottom: 20px;

  p {
    margin: 5px 0;
  }
`

const Button = styled.button`
  background-color: ${colors.greenbutton};
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: 0.2s ease;
  &:hover {
    background-color: ${colors.button};
    color: ${colors.greenbutton};
  }
`

const EmailLink = styled.a`
  display: inline-block;
  margin-top: 16px;
  background-color: #2563eb;
  color: white;
  padding: 12px 20px;
  border-radius: 10px;
  text-decoration: none;
  font-size: 16px;
  margin-left: 20px;

  &:hover {
    background-color: #1e40af;
  }
`

const SuccessText = styled.p`
  margin-top: 10px;
  color: green;
  font-weight: 500;
`

const PasswordBox = styled.form`
  background: white;
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 30px;
  text-align: center;

  input {
    margin-top: 10px;
    padding: 10px;
    font-size: 16px;
    border-radius: 8px;
    border: 1px solid #ccc;
    width: 100%;
    margin-bottom: 15px;
  }

  button {
    background-color: ${colors.greenbutton};
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
      background-color: ${colors.button};
    }
}`